module.exports = __webpack_public_path__ + "media/images/vendors/verndors-77c325a5000fe262dce9644febcd4ac4.png";